import { mapValues, sumBy } from "lodash-es";

import { mapDictionaryKey } from "components/Filters/helpers";
import { FilterItemOption } from "components/Filters/types";
import { SEARCH_STACK_SUGGESTIONS_DICTIONARY, StackSuggestions } from "constants/stack";
import { URL_FILTER_TAB_KEY } from "constants/urlQueryKeys";
import { StackState } from "types/generated";

import { PREDEFINED_FILTER_STATES, PredefinedFilterType } from "./constants";

export const getFilterKey = (key: StackSuggestions | string) => {
  return mapDictionaryKey(key, SEARCH_STACK_SUGGESTIONS_DICTIONARY);
};

export const getPredefinedFilterTab = (searchParams: URLSearchParams) =>
  searchParams.get(URL_FILTER_TAB_KEY) || PredefinedFilterType.AllStacks;

type PredefinedFilterCountsContext = {
  activeTab: string;
  filteredCount?: number;
};

export const getPredefinedFilterCounts = (
  stateOptions: Pick<FilterItemOption, "value" | "count">[] | undefined,
  { activeTab, filteredCount }: PredefinedFilterCountsContext
): Record<PredefinedFilterType, number> | undefined => {
  if (!stateOptions) {
    return undefined;
  }

  const countsByState = new Map(stateOptions.map(({ value, count }) => [value, count ?? 0]));

  const sumStates = (states: readonly StackState[]) =>
    sumBy(states, (state) => countsByState.get(state) ?? 0);

  // State counts ignore the state filter, so on the All tab only filteredCount matches a sidebar State filter
  const allStacksCount =
    activeTab === PredefinedFilterType.AllStacks && filteredCount !== undefined
      ? filteredCount
      : sumBy(stateOptions, ({ count }) => count ?? 0);

  return {
    [PredefinedFilterType.AllStacks]: allStacksCount,
    ...mapValues(PREDEFINED_FILTER_STATES, sumStates),
  };
};
